export default "__VITE_ASSET__I26ZepQT__"